var _style, _rect, _rect2, _rect3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgSoundBars = function SvgSoundBars(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n    .spinner_7uc5 {\n      animation: spinner_3l8F 1.3s cubic-bezier(0.175, 0.885, 0.32, 1.275) infinite;\n      animation-delay: -0.9s;\n    }\n    .spinner_RibN {\n      animation-delay: -0.7s;\n    }\n    .spinner_ZAxd {\n      animation-delay: -0.5s;\n    }\n    @keyframes spinner_3l8F {\n      0% {\n        opacity: 0.8;\n      }\n      66.66% {\n        opacity: 0.9;\n      }\n      0%, 66.66% {\n        animation-timing-function: cubic-bezier(0.14, 0.73, 0.34, 1);\n        y: 8px; /* Adjusted from 6px to 8px */\n        height: 8px; /* Adjusted from 12px to 8px */\n      }\n      33.33% {\n        animation-timing-function: cubic-bezier(0.65, 0.26, 0.82, 0.45);\n        y: 4px; /* Adjusted from 1px to 4px */\n        height: 16px; /* Adjusted from 22px to 16px */\n        opacity: 0.9;\n      }\n      100% {\n        opacity: 1;\n      }\n    }\n  ")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "spinner_7uc5 spinner_RibN",
    x: 6.5,
    y: 8,
    width: 2.8,
    height: 8,
    rx: 1.4,
    ry: 1.4
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "spinner_7uc5",
    x: 10.1,
    y: 8,
    width: 2.8,
    height: 8,
    rx: 1.4,
    ry: 1.4
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "spinner_7uc5 spinner_ZAxd",
    x: 13.7,
    y: 8,
    width: 2.8,
    height: 8,
    rx: 1.4,
    ry: 1.4
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSoundBars);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "sound-bars.ade920f4f846e6fed1792764103204c6.svg";